import { Space } from 'lib/bytes';

import { ISubscription } from './BuyModal.types';

interface ISharedProps {
    link: string | null;
    hasError: boolean;
    isLoading: boolean;
}

interface IMapStateBase {
    subscription: ISubscription;
    userTotalSpace: Space;
}

export enum EBuyContentSize {
    small = 'small',
    large = 'large',
}

export enum EBuyContentType {
    TRIAL = 'trial',
}

interface IOwnPropsBase {
    onClose: Function;
    onSuccess: Function;
    onCancel?: () => void;
    onBuyClick?: () => void;
    retry?: Function | null;
    id: string;
    isPromocodesTrial?: boolean;
    renew?: boolean;
    size?: EBuyContentSize;
    type?: EBuyContentType;
    onDmrResizeEvent?: Function;
    qaId?: string;
}

export interface IOwnProps extends IOwnPropsBase, Partial<ISharedProps> {}

export interface IMapState extends IMapStateBase, ISharedProps {}

export interface IDispatchProps {
    buySubscription: Function;
    buyTrialSubscription: Function;
}

export interface IState {
    node: any;
    dmrLoading: boolean;
    dmrHeight: number;
    hasError: boolean;
    expandFrame: boolean;
}

export interface IProps extends IOwnPropsBase, IMapStateBase, ISharedProps, IDispatchProps {}
